
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exclusao-de-conta",
      function () {
        return require("private-next-pages/exclusao-de-conta.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exclusao-de-conta"])
      });
    }
  